import * as z from 'zod/mini';

/**
 * Interface definition for the Register API, exposed through
 * /api/auth/register.
 */
export const signUpDefinition = z.object({
  request: z.object({
    /**
     * The email address of the account that should be created.
     */
    email: z.string(),

    /**
     * The password associated with that account, SHA256 hashed.
     */
    password: z.string().check(z.length(64)),

    /**
     * The user's first name.
     */
    firstName: z.string(),

    /**
     * The user's last name.
     */
    lastName: z.string(),

    /**
     * Date on which the user was born. (YYYY-MM-DD)
     */
    birthdate: z.string(),

    /**
     * Phone number of the user, in an undefined format.
     */
    phoneNumber: z.string(),
  }),

  response: z.strictObject({
    /**
     * Whether the sign up attempt was successful.
     */
    success: z.boolean(),

    /**
     * The error message that occurred when `success` is not set to true.
     */
    error: z.optional(z.string()),
  }),
});

export type SignUpDefinition = z.infer<typeof signUpDefinition>;
